import { render, staticRenderFns } from "./Pnr.vue?vue&type=template&id=5f8d1c10&"
import script from "./Pnr.vue?vue&type=script&lang=js&"
export * from "./Pnr.vue?vue&type=script&lang=js&"
import style0 from "./Pnr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports